import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { CardButton } from 'components'
import { useFirebaseEvent } from 'hooks'
import { STATICS } from 'statics'
import { setModal } from 'slices/modal'
import { setDrawer } from 'slices/drawer'
import { financialService } from 'services'
import { DRAWER_KEY, EVENT_STATUS, FIREBASE_EVENTS, MODAL_KEYS } from 'app-constants'
import {
  MY_CREDIT_CARDS_ERROR_MESSAGE,
  MY_CREDIT_CARDS_ERROR_TITLE,
  MY_CREDIT_CARDS_REDIRECT_BUTTON_LABEL,
  MY_CREDIT_CARDS_REDIRECT_DESCRIPTION,
} from '../../constants'
import './style.scss'

export function RecurringPayment({ contractId, contract = {}, setError }) {
  const [isLoading, setIsLoading] = useState(false)
  const { sendEvent } = useFirebaseEvent()
  const dispatch = useDispatch()
  const { getRecurringPaymentLink } = financialService()

  function handleRedirectModal(url) {
    dispatch(setDrawer(DRAWER_KEY.NONE))
    dispatch(
      setModal({
        key: MODAL_KEYS.REDIRECT_LINK,
        data: {
          url,
          description: MY_CREDIT_CARDS_REDIRECT_DESCRIPTION,
          buttonLabel: MY_CREDIT_CARDS_REDIRECT_BUTTON_LABEL,
        },
      })
    )
  }

  async function handleCreditCardClick() {
    try {
      setIsLoading(true)
      const {
        data: { recurringPaymentLink },
      } = await getRecurringPaymentLink(contractId)
      sendEvent(FIREBASE_EVENTS.CLICK_ON_MY_CREDIT_CARD_RECURRENCY_PAYMENT)

      handleRedirectModal(recurringPaymentLink)
    } catch (err) {
      console.error(err)
      setError({
        title: MY_CREDIT_CARDS_ERROR_TITLE,
        text: MY_CREDIT_CARDS_ERROR_MESSAGE,
      })
      sendEvent(FIREBASE_EVENTS.CLICK_ON_MY_CREDIT_CARD_RECURRENCY_PAYMENT, EVENT_STATUS.ERROR)
    } finally {
      setIsLoading(false)
    }
  }

  function renderContent() {
    const { enableRecurringPayment, recurringPayment } = contract
    const disabledCreditCardButton = !enableRecurringPayment || !recurringPayment

    if (disabledCreditCardButton) return

    return (
      <CardButton
        icon={<STATICS.CREDIT_CARD />}
        className='recurring-payment-button'
        onClick={handleCreditCardClick}
        isLoading={isLoading}
      >
        Meus cartões
      </CardButton>
    )
  }

  return renderContent()
}
